import { render, staticRenderFns } from "./CompensationBl.vue?vue&type=template&id=917fbd12&scoped=true&"
import script from "./CompensationBl.vue?vue&type=script&lang=js&"
export * from "./CompensationBl.vue?vue&type=script&lang=js&"
import style0 from "./CompensationBl.vue?vue&type=style&index=0&id=917fbd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917fbd12",
  null
  
)

/* custom blocks */
import block0 from "./CompensationBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports